<template>
  <div class="container" v-show="showSuggestion">
    <div class="top">
      <h2>
        <span>智能</span>
        <i>推荐</i>
      </h2>
      <button>
        <Icon icon="tabler:refresh" />
        <span>换一批</span>
      </button>
    </div>
    <ul>
      <li v-for="item in bookList" :key="item">
        <BookCover :size="160" :clickable="false" :showActions="false" />
        <h3>数字媒体艺术概论</h3>
        <p>Introduction to Digital Media Arts</p>
      </li>
    </ul>
  </div>
</template>

<script>
import BookCover from '@/components/BookCover.vue'
import { Icon } from '@iconify/vue2'
export default {
  name: 'SmartSuggestion',
  components: {
    BookCover,
    Icon,
  },
  props: {},
  data() {
    return {
      bookList: [1, 2, 3, 4, 5, 6],
      showSuggestion: false,
    }
  },
  computed: {},
  methods: {
    async setShowSuggestion() {
      const body = {
        //固定传值
        type: 'configitem',
        filter: {
          itemList: [
            {
              fieldName: 'name',
              relationOperator: 'equal',
              searchWord: 'isEnableIntelligentRecommend',
            },
          ],
        },
        field: 'variablevalue',
      }
      const res = await this.$http.post('/api/v1/platform/DataModel/objectlist', body)
      const show = this.lodash.get(
        res,
        'returnvalue.recordlist[0].variablevalue',
        'false'
      )
      const showSuggestion = show.toLowerCase() === 'true'
      localStorage.setItem('showSuggestion', showSuggestion)
      this.showSuggestion = showSuggestion
    },
  },

  mounted() {
    this.setShowSuggestion()
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  .top {
    display: flex;
    justify-content: space-between;
    h2 {
      font-size: 20px;
      color: #333;
      i {
        font-style: normal;
        color: $mainColor;
      }
    }
    button {
      display: flex;
      align-items: center;
      background: none;
      padding: 0;
      border: 0;
      font-size: 16px;
      color: #666;
      cursor: pointer;
      svg {
        margin-right: 10px;
      }
    }
  }
  ul {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    padding: 0;
    list-style: none;
    li {
      width: 160px;
      font-size: 16px;
      h3 {
        margin-top: 15px;
        font-weight: normal;
        font-weight: 400;
        color: #333;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p {
        margin-top: 10px;
        font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
        color: #999;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
